import React from "react";
import Chip from "@mui/material/Chip";
import { statusColors } from "../../../constants/inventoryRequestStatus";
import { getHighestPriorityStatus, statusOrder } from "../../../views/inventory/requests/VaStatus";

const internalWorkOrderLabels = {
  picked: "Staged",
  completed: "Completed",
  canceled: "Cancelled",
};

export default function OrderStatusChip({ vaStatus, orderType = "inventoryRequest", sx = {} }) {
  const statusKey = getHighestPriorityStatus(vaStatus) || "submitted";
  const statusLabel =
    (orderType === "internalWorkOrder" && internalWorkOrderLabels[statusKey]) ||
    statusOrder.find((status) => status.key === statusKey)?.label ||
    "Submitted";
  const backgroundColor = statusColors[statusKey] || statusColors.submitted;

  return (
    <Chip
      label={statusLabel}
      size="small"
      sx={{
        height: 20,
        borderRadius: 1,
        backgroundColor,
        border: `1px solid ${backgroundColor}`,
        color: "black",
        fontWeight: 500,
        "& .MuiChip-label": {
          px: 0.75,
          fontSize: 11,
          lineHeight: 1.2,
        },
        ...sx,
      }}
    />
  );
}
